import Vue from 'vue'
import VtComboSelect from '@/components/common/vt-combo-select/VtComboSelect.vue'
Vue.component('VtComboSelect', VtComboSelect)
